<template>
	<v-menu
		v-if="availableLocales.length > 1"
		v-model="menu"
		:open-on-focus="false"
		location="center center"
		submenu
		:close-on-content-click="false"
	>
		<template #activator="{ props }">
			<v-list-item
				v-bind="props"
				:title="`${t('component.locale.language')}: ${t(`component.locale.${localeI18n}`)}`"
				:prepend-icon="t('component.locale.icon')"
				append-icon="fas fa-chevron-right"
				data-test="profile-menu__locale-list-item"
			></v-list-item>
		</template>
		<v-list
			:title="t('component.locale.name')"
			:selected="[localeI18n]"
			:items="values"
			color="primary"
			@update:selected="changeLocale"
		>
		</v-list>
	</v-menu>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useLocaleManager } from 'composables/useLocaleManager.ts'

const menu = ref(false)

const { t, locale: localeI18n, availableLocales } = useI18n()
const localeManager = useLocaleManager()

const values = computed(() => [
	{
		title: t(`component.locale.name`),
		type: 'header',
		props: {
			twoLine: true,
			appendIcon: '$close',
			onClick: () => {
				menu.value = false
			},
		},
	},
	{
		type: 'divider',
	},
	...availableLocales.map((locale) => ({
		title: t(`component.locale.${locale}`),
		value: locale,
	})),
])

function changeLocale(value: string[]) {
	const [local] = value
	if (!local) return
	localeManager.setLocale(local)
	menu.value = false
}
</script>
<style></style>
